var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDispatchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    fillRule: "nonzero",
    d: "M 0 8 L 0 12 L 18 12 L 18 14 L 0 14 L 0 16 L 15 16 L 15 18 L 0 18 L 0 20 L 12 20 L 12 22 L 0 22 L 0 24 L 9 24 L 9 26 L 0 26 L 0 37 C 0 38.652344 1.347656 40 3 40 L 7.09375 40 C 7.570313 42.835938 10.035156 45 13 45 C 15.964844 45 18.429688 42.835938 18.90625 40 L 31 40 L 31 10.90625 C 31 9.359375 29.640625 8 28.09375 8 Z M 33 15 L 33 40 L 34.09375 40 C 34.570313 42.832031 37.03125 45 40 45 C 42.96875 45 45.425781 42.832031 45.90625 40 L 47 40 C 48.542969 40 50 38.542969 50 37 L 50 27.40625 C 50 25.445313 48.585938 23.347656 48.40625 23.09375 L 44.28125 17.5625 C 43.511719 16.601563 41.933594 15 40 15 Z M 38 17 L 40 17 C 40.789063 17 41.796875 17.695313 42.6875 18.8125 L 46.78125 24.28125 C 47.082031 24.714844 47.808594 25.9375 47.96875 27 L 39 27 C 38.550781 27 38 26.449219 38 26 Z M 13 35 C 15.222656 35 17 36.777344 17 39 C 17 41.222656 15.222656 43 13 43 C 10.777344 43 9 41.222656 9 39 C 9 36.777344 10.777344 35 13 35 Z M 40 35 C 42.207031 35 44 36.792969 44 39 C 44 41.207031 42.207031 43 40 43 C 37.792969 43 36 41.207031 36 39 C 36 36.792969 37.792969 35 40 35 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDispatchIcon);
export default __webpack_public_path__ + "static/media/dispatchIcon.b6b2dfd4cb33be5d3b2ab01726cea6a1.svg";
export { ForwardRef as ReactComponent };